import { createLegacyBindingContext } from "./binding-context";

export const LEGACY_BOOTSTRAP_STATE_SYMBOL = Symbol.for("@visactor/vrender-core/legacy-bootstrap-state");

function createLegacyBootstrapState() {
    return {
        legacyBindingContext: createLegacyBindingContext(),
        preloaded: !1
    };
}

export function getLegacyBootstrapState() {
    const scope = globalThis;
    return scope[LEGACY_BOOTSTRAP_STATE_SYMBOL] || (scope[LEGACY_BOOTSTRAP_STATE_SYMBOL] = createLegacyBootstrapState()), 
    scope[LEGACY_BOOTSTRAP_STATE_SYMBOL];
}
//# sourceMappingURL=bootstrap-state.js.map
